export default "__VITE_ASSET__CYCZmuLp__"